module.exports = __webpack_public_path__ + "img/right.6d3838a8.svg";